import SceneComponent from '../../Components/Babylon/SceneComponent';

import DataContext from '../../DataContext';
import { Avatar, Box, Button, Modal, Typography } from '@mui/material';
import { useContext, useEffect, useRef, useState } from 'react';
import { isMobile, isIOS } from 'react-device-detect';
import * as BABYLON from 'babylonjs';
import * as querystring from 'query-string'

import logo from '../../image/logo.png';
import logo2 from '../../image/Onepointlive.png';

const onRender = (scene: BABYLON.Scene) => {

};

export default function Page360() {
    const { selected } = useContext(DataContext);
    const containerRef = useRef(null);
    const [isAllowed, setIsAllowed] = useState(false);
    const [open, setOpen] = useState(true);
    const handleClose = () => setOpen(false);

    const queryParams = querystring.parse(window.location.search);
    console.log(queryParams);
    const returnUrl = queryParams.returnUrl;
    let returnLink = "https://www.onepoint.live/";
    if (queryParams.returnUrl)
        returnLink = atob(String(queryParams.returnUrl));
    console.log(returnLink);


    useEffect(() => {
        var check = sessionStorage.getItem("isAllowed");
        setIsAllowed((check === "true"));
    }, [])

    const allowPermission = () => {
        if (isMobile && isIOS) {
            (DeviceMotionEvent as any).requestPermission()
                .then((response: any) => {
                    if (response === 'granted') {
                        setIsAllowed(true);
                        sessionStorage.setItem("isAllowed", "true");
                        window.location.reload();
                    }
                })
                .catch((err: any) => {
                    console.error(err);
                })
            setOpen(false);
        } else {
            setOpen(false);
        }
    }

    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        display: 'flex',
        justifyContent: 'center',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <div>

            <SceneComponent
                antialias={true}
                onRender={onRender}
                className="cursor-pointer w-full h-full absolute top-0 left-0"
                id="my-canvas"
                data360={selected}
            />
            

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: 'fit-content',
                    borderRadius: 5,
                    paddingRight: '1rem',
                    color: 'text.secondary',
                    '& svg': {
                        m: 1.5
                    },
                    '& hr': {
                        mx: 0.5
                    },

                }}
                ref={containerRef}
                >
        <div className="otherMenu z-10">
            <a className="link"  data-cke-saved-href="" href={returnLink}>
                <div className="img"></div>
            </a>
            <a className="link">Experience 360°</a>
        </div>

                {/* <Avatar src={logo} alt="logo Livepoint" sx={{ width: '3rem', height: '3rem', margin: '1rem' }} /> */}
                {
                    isMobile && !isAllowed && isIOS ?
                        <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    Please allow the device to use space orientation to continue
                                </Typography>
                                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                    <Button onClick={allowPermission}>Allow</Button>
                                </Typography>
                            </Box>
                        </Modal> : ''
                }
            </Box>
        </div>
    )
}